import { createFileRoute } from "@tanstack/react-router";
import { Pricing } from "./priser";

export const Route = createFileRoute("/es/precios")({
  head: () => ({
    meta: [
      { title: "Precios – planes gratis, Plus y Pro | Sellavo" },
      { name: "description", content: "Empieza gratis con 5 anuncios al mes o cambia a Plus o Pro para más." },
      { property: "og:title", content: "Precios – planes gratis, Plus y Pro | Sellavo" },
      { property: "og:description", content: "Empieza gratis con 5 anuncios al mes o cambia a Plus o Pro para más." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/precios" }],
  }),
  component: Pricing,
});
